module.exports = __webpack_public_path__ + "static/media/publish-schedule-stories-tabletPro-es.112b027a.webp";